"use client"

export type CookieStoreEventTarget = Pick<EventTarget, "addEventListener" | "removeEventListener">

export function getCookieStoreEventTarget(): CookieStoreEventTarget | null {
  if (typeof window === "undefined") {
    return null
  }

  const cookieStore = (window as Window & { cookieStore?: CookieStoreEventTarget }).cookieStore

  if (!cookieStore || typeof cookieStore.addEventListener !== "function" || typeof cookieStore.removeEventListener !== "function") {
    return null
  }

  return cookieStore
}
